import type { ImplementedCopilotFeatures, CopilotSettingsStore } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';
import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';

type GetAgendaScenarios = Extract<ImplementedCopilotFeatures, 'AgendaGeneration'>;

const isIntelligentDraftAgendaV3Enabled = (): ((
    scenario: 'AgendaGeneration',
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    shouldIgnoreUserPreferences?: boolean
) => boolean | undefined) =>
    createStoreCheckForGenericEnablement<GetAgendaScenarios, boolean>(
        'AgendaGeneration',
        isIntelligentDraftAgendaV3EnabledInternal
    );

export default isIntelligentDraftAgendaV3Enabled;

function isIntelligentDraftAgendaV3EnabledInternal(
    store: CopilotSettingsStore,
    _language: string,
    scenario: GetAgendaScenarios,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    skipGroupMailboxCheck?: boolean
): boolean {
    // Feature is not supported for Group Mailboxes
    if (!skipGroupMailboxCheck && mailboxInfo.type === 'GroupMailbox') {
        return false;
    }

    if (store.isEnabled) {
        const featureEnabled = store.featureInfo.get(scenario);
        if (featureEnabled?.isEnabled) {
            const appSettings = getApplicationSettings('Copilot', mailboxInfo);
            return (
                !!isCopilotFeatureEnabled(
                    scenario,
                    mailboxInfo,
                    skipLanguageCheck ?? appSettings.enableMultiLanguage
                ) &&
                isFeatureEnabled('time-copilot-ida-sydney') &&
                appSettings.calendarElaborateEnabled // This is controlled through the Killswitch ECS here: https://ecs.skype.com/Substrate/OutlookWebClient/configurations/1092852
            );
        }
    }
    return false;
}
